<template>
  <li class="rhg-modal-filter-chip" :class="{ 'selected': isSelected, 'rhg-brand-filter-padding': isBrandFilter }" @click="selectFilter(code, id)">
    <img v-if="isBrandFilter" :src="urlLogo(code)" class="rhg-modal-filter-chip-brand-logo" />
    <span v-if="isRatingFilter" class="rhg-modal-filter-chip-rating">{{ translate(label) }}
      <img
        :src="ratingImage"
        alt="tripadvisor rating"
        class="tripadvisor-rating"
      /></span>
    <span v-else>{{ label }} </span>
    <i v-if="isSelected" class="rhg-font-icon--close-icon" @click="unselectFilter($event, code)" ref="iconClose" />
  </li>
</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'
import { getRatingImageForNumber } from '@/infrastructure/Tripadvisor'

export default {
  name: 'Chip',
  emits: ['filterSelected', 'notSelectedFilters'],
  props: {
    label: {
      type: String,
      required: true
    },
    code: {
      type: String,
      required: true
    },
    id: {
      type: String,
      requied: true
    },
    selectedFilters: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isSelected: false,
    iconUrl: `${assetsUrl}/img/icons/markers/`
  }),
  watch: {
    selectedFilters(newValue) {
      const selectedFilter = newValue.filter(filter => filter.code === this.code)
      this.isSelected = selectedFilter.length > 0
    }
  },
  methods: {
    selectFilter(code, id) {
      this.$emit('filterSelected', code, id)
    },
    unselectFilter(event, code) {
      event.stopPropagation()
      this.$emit('notSelectedFilters', code)
    },
    urlLogo(code) {
      return this.iconUrl + code + '-round.png'
    }
  },
  computed: {
    isBrandFilter() {
      return this.id === 'brand'
    },
    isRatingFilter () {
      return this.id === 'rating'
    },
    ratingImage () {
      return getRatingImageForNumber(Number(this.code), false)
    }
  }
}
</script>

<style lang="scss" scoped>
.rhg-modal-filter-chip {
  padding: 8px 16px;
  border: 1px solid #D8D8D8;
  border-radius: 28px;
  width: fit-content;
  font-size: 16px;
  font-weight: normal;
  line-height: 22px;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  display: flex;
  align-items: center;

  &:hover {
    border: 1px solid #29343D;
    font-weight: 700;
  }

  &.selected {
    border: 1px solid #29343D;
    font-weight: 700;
  }

  .rhg-modal-filter-chip-brand-logo {
    width: 28px;
    height: 28px;
    margin-right: 8px;
  }

  i {
    font-size: 15px !important;
    top: 5px;
    margin-left: 10px;

    &::before {
      font-weight: 700;
    }
  }

  &-rating {
    display: flex
  }
}

.rhg-brand-filter-padding {
  padding: 8px 16px 8px 4px;
}

html[dir="rtl"]{
  .rhg-brand-filter-padding {
    padding: 8px 4px 8px 16px;
  }
  .rhg-modal-filter-chip-brand-logo {
    margin-right: unset;
    margin-left: 8px;
  }

  .rhg-modal-filter-chip {
    i {
      margin-right: 10px;
      margin-left: unset;
    }
    &-rating img {
      flex-direction: row-reverse;
      transform: rotate(180deg)
    }
  }
}
</style>
